import { i18n } from "../../../main";
import { compressData } from "../../../utils/array";
import { getMatrixOfValue } from "../../../utils/util";
import api from "../../api";
import { hfInstance } from "../../Cells";
import { rangeToHfFormat } from "../CellsHelper";
const utils = (context) => {};
const main = (context) => {
  const { dispatch, rootState, rootGetters, currentSheet, currentSheetId, currentSheetName, current, designId } =
    context;
  return {
    async set(range, value) {
      const cellIds = rootGetters["cells/rangeIds"](range);
      const previousValueMatrix = hfInstance.getRangeSerialized(rangeToHfFormat(currentSheet, range));
      // reset the cells before setting new data because of (Value of the formula cell is not computed) bug
      hfInstance.setCellContents(
        { sheet: currentSheetId, row: range[1], col: range[0] },
        getMatrixOfValue(range, null)
      );
      const changes = hfInstance.setCellContents({ sheet: currentSheetId, row: range[1], col: range[0] }, value);
      setTimeout(() => {
        dispatch("corners/setChangedCells", changes, { root: true });
      }, 0);
      // Added this because with Named Range formula recalculates not working fine
      hfInstance.rebuildAndRecalculate();

      await dispatch("views/updateViewData", cellIds, { root: true });
      dispatch("cells/toggleRedrawCanvas", null, { root: true });

      await dispatch("persistSelectedCells", { range, value: value });
      return async () => {
        hfInstance.setCellContents(
          { sheet: currentSheetId, row: range[1], col: range[0] },
          getMatrixOfValue(range, null)
        );
        const changes = hfInstance.setCellContents(
          { sheet: currentSheetId, row: range[1], col: range[0] },
          previousValueMatrix
        );
        setTimeout(() => {
          dispatch("corners/setChangedCells", changes, { root: true });
        }, 0);
        await dispatch("views/updateViewData", cellIds, { root: true });
        await dispatch("persistSelectedCells", { range, value: previousValueMatrix });
      };
    },
    async remove(range) {
      const previousValueMatrix = hfInstance.getRangeSerialized(rangeToHfFormat(currentSheet, range));

      const matrix = getMatrixOfValue(range, null);
      hfInstance.setCellContents({ sheet: currentSheetId, row: range[1], col: range[0] }, matrix);

      const rowsInRange = rootGetters["cells/rowsInRange"](range);
      const columnsInRange = rootGetters["cells/columnsInRange"](range);
      const cellIds = rootGetters["cells/rangeIds"](range);

      const payload = { sheetName: currentSheetName, rowsInRange, columnsInRange };
      const compressedData = compressData(payload);

      dispatch("toggleRedrawCanvas");
      await api.patch(`designs/${designId}/delete-selected-cells`, { compressedData });
      await dispatch("views/updateViewData", cellIds, { root: true });
      return async () => {
        this.set(range, previousValueMatrix);
      };
    },
    async setActivityColumnContent(rowIndexes) {
      const names = i18n.global.tm("names.activity");

      const activityColumnIndex = current.design.columnMap["Activity"].index;
      const range = [activityColumnIndex, rowIndexes[0], activityColumnIndex, rowIndexes[0] + rowIndexes.length - 1];
      const dataMatrix = rowIndexes.map((item) => [names[(Math.random() * Object.keys(names).length).toFixed()]]);

      hfInstance.setCellContents({ sheet: currentSheetId, row: rowIndexes[0], col: activityColumnIndex }, dataMatrix);
      await dispatch("persistSelectedCells", { range, value: dataMatrix });

      dispatch("cells/toggleRedrawCanvas", null, { root: true });

      return async () => {
        await this.remove(range);
      };
    },
    async editCellContentsByIds(ids, values) {
      const prevValues = [];

      ids.forEach((id, index) => {
        const [columnIndex, rowIndex] = rootGetters["cells/getCellCoordinate"](id);
        if (columnIndex == null || rowIndex == null) return;
        prevValues[index] =
          hfInstance.getCellSerialized({ sheet: currentSheetId, col: columnIndex, row: rowIndex }) ?? "";
      });

      const changes = hfInstance.batch(() => {
        ids.forEach((id, index) => {
          const [columnIndex, rowIndex] = rootGetters["cells/getCellCoordinate"](id);
          if (columnIndex == null || rowIndex == null) return;
          hfInstance.setCellContents({ sheet: currentSheetId, col: columnIndex, row: rowIndex }, [[values[index]]]);
        });
      });

      setTimeout(() => {
        dispatch("corners/setChangedCells", changes, { root: true });
      }, 0);

      await dispatch("views/updateViewData", ids, { root: true });
      dispatch("cells/toggleRedrawCanvas", null, { root: true });
      await dispatch("cells/persistCellsByIds", { ids, values }, { root: true });
      return async () => {
        const changes = hfInstance.batch(() => {
          ids.forEach((id, index) => {
            const [columnIndex, rowIndex] = rootGetters["cells/getCellCoordinate"](id);
            if (columnIndex == null || rowIndex == null) return;
            hfInstance.setCellContents({ sheet: currentSheetId, col: columnIndex, row: rowIndex }, [
              [prevValues[index]],
            ]);
          });
        });
        setTimeout(() => {
          dispatch("corners/setChangedCells", changes, { root: true });
        }, 0);
        await dispatch("views/updateViewData", ids, { root: true });
        dispatch("cells/toggleRedrawCanvas", null, { root: true });
        await dispatch("cells/persistCellsByIds", { ids, values: prevValues }, { root: true });
      };
    },
  };
};

export default (context) => {
  return {
    main: main(context),
    utils: utils(context),
  };
};
